import { SwitchTransition, Transition } from 'react-transition-group';
import { Fade } from '@material-ui/core';
import PropTypes from 'prop-types';

const ToggleComponent = ({ children, inKey }) => {
  return (
    <SwitchTransition mode="out-in">
      <Transition
        key={inKey ? 'first' : 'second'}
        timeout={300}
        addEndListener={(node, done) => {
          node.addEventListener('transitionend', done, false);
        }}
      >
        {state => (
          <Fade in={state === 'entered'} unmountOnExit>
            <div>{children}</div>
          </Fade>
        )}
      </Transition>
    </SwitchTransition>
  );
};

ToggleComponent.propTypes = {
  children: PropTypes.node.isRequired,
  inKey: PropTypes.bool.isRequired,
};

export default ToggleComponent;
